import React from "react";

function Header(props) {
	let dev = window.location.href.includes("localhost") /*|| window.location.href.includes("dev")*/;
	return (
		<>
			<div className="row header-outer pageRoleSelectorHeader">
				<div className="">
					<header data-domain={props.dataDomain} data-type={props.dataType} data-theme={props.dataTheme} data-is-preview={props.dataIsPreview}
						data-search-enabled={props.dataSearchEnabled} data-is-main={props.dataIsMain} data-is-myts={props.dataIsMyts} data-language-enableds={props.dataLanguageEnabled}
						data-v-app="">
						{
							dev ? (
								<>
									<div data-v-fe9a44d0="" className="header" id="frame-top">
										<div data-v-ebd4b33b="" data-v-fe9a44d0="" className="header-desktop">
											<Tool />
											<hr data-v-ebd4b33b="" className="separator" />
											<Menu />
										</div>
									</div>
									<div data-v-6a5b1d5f="" data-v-fe9a44d0="" id="announcer" className="announcer sr-only" aria-atomic="true"
										aria-live="polite">
									</div>
								</>
								) : (
								<>
								</>
								)
						}
					</header>
				</div>
				<div className="header-title" >
					<h1 style={{ marginBottom: "8px" }}>Jogosultság választás</h1>
				</div>
			</div>
		</>
	);
}
export default Header;

function Tool() {
	return (
		<>
			<div data-v-ebd4b33b="" className="fr-container">
				<nav data-v-ebd4b33b="" className="skiplink" aria-label="Ugrási lehetőségek">
					<div data-v-ebd4b33b="" className="fr-container">
						<ul data-v-ebd4b33b="">
							<li data-v-ebd4b33b="">
								<a data-v-ebd4b33b="" href="#frame-megamenu">
									Ugrás az elsődleges navigációhoz
								</a>
							</li>
							<li data-v-ebd4b33b="">
								<a data-v-ebd4b33b="" href="#">
									Ugrás az oldal tartalmához
								</a>
							</li>
						</ul>
					</div>
				</nav>
				<div data-v-ebd4b33b="" className="segment-wrapper">
					<nav data-v-b3df50ff="" data-v-ebd4b33b="" className="segmentbar"
						aria-labelledby="frame-segmentbar">
						<h2 data-v-b3df50ff="" className="sr-only" id="frame-segmentbar">
							Üzletág választó navigáció
						</h2>
						<ul data-v-b3df50ff="">
							<ToolElements text="Lakossági" />
							<ToolElements text="Üzleti" className="active" />
							<ToolElements text="Vállalati megoldások" />
							<ToolElements text="Nagyker" />
							<ToolElements text="Rólunk" />
							<ToolElements text="Karrier" />
						</ul>
					</nav>
					<div data-v-3e250ed4="" data-v-ebd4b33b="" className="languages-menu" aria-labelledby="frame-languages">
						<h2 data-v-3e250ed4="" className="sr-only" id="frame-languages">
							Nyelv kiválasztása
						</h2>
						<a data-v-3e250ed4="" className="language"
							href="https://www.telekom.hu/business/selfcare"
							target="Link to the www.telekom.hu/business/selfcare page"
							title="Link to the www.telekom.hu/business/selfcare page">
							English
						</a>
					</div>
				</div>
			</div>
		</>
	)
}

function ToolElements(props) {
	return (
		<>
			<li data-v-b3df50ff="">
				<a data-v-b3df50ff=""
					href="https://www.telekom.hu/karrier" className={props.className}
					aria-label="Karrier Link a www.telekom.hu/karrier oldalra">
					<span
						data-v-b3df50ff="" className="sr-only">
						Kiválasztott üzletág
					</span>
					{props.text}
				</a>
			</li>
		</>
	)
}

function UserMenu() {
	return (
		<>
			<div data-v-69bb98d4="" data-v-ebd4b33b="" className="user-menu">
				<button
					data-v-69bb98d4="" className="user-menu-logged-in-button" role="menuitem"
					tabIndex="-1" aria-label="Felhasználói menü lenyitása" aria-expanded="false"
					aria-controls="user-menu-dropdown" aria-haspopup="true">
					<div data-v-69bb98d4="" className="icon-background">
						<svg data-v-69bb98d4=""
							className="icon" width="20" height="20" viewBox="0 0 20 20" fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<use data-v-69bb98d4="" href="#icon-user-desktop" />
						</svg>
					</div>
					<span data-v-69bb98d4="" className="name">
						Fehér Tamás
					</span>
				</button>
			</div>
		</>
	);
}

function Search() {
	return (
		<>
			<div data-v-ebd4b33b="" className="search">
				<h2 data-v-ebd4b33b="" className="sr-only">
					Keresés
				</h2>
				<button data-v-ebd4b33b=""
					aria-label="Kereső lenyitása" aria-haspopup="true" aria-expanded="false"
					aria-controls="frame-search-dropdown" tabIndex="-1">
					<svg data-v-ebd4b33b=""
						className="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
						viewBox="0 0 24 24" fill="none">
						<title data-v-ebd4b33b="">
							Keresés
						</title>
						<use data-v-ebd4b33b="" href="#icon-search" />
					</svg>
				</button>
			</div>
		</>
	);
}
function Menu() {
	return (
		<>
			<div data-v-ebd4b33b="" className="fr-container">
				<div data-v-ebd4b33b="" className="main-menu-wrapper">
					<div data-v-ebd4b33b="" className="main-menu">
						<div className="logo">
							<a href="https://www.telekom.hu/uzleti/fooldal" aria-label="Link a /uzleti/fooldal oldalra" tabIndex="0">
								<svg width="24"
									height="28" viewBox="0 0 24 28" fill="none"
									xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
									<use href="#icon-logo" />
								</svg>
							</a>
						</div>
						<div className="navigation-container">
							<nav id="frame-megamenu" aria-labelledby="primary-navigation">
								<h2 className="sr-only" id="primary-navigation">
									Elsődleges navigáció
								</h2>
								<ul className="nav" role="menubar">
									<MenuElemenmt text="Készülékek" />
									<MenuElemenmt text="Szolgáltatások" />
									<MenuElemenmt text="Ügyintézés" />
								</ul>
							</nav>
						</div>
					</div>
					<Search />
					<UserMenu />
				</div>
			</div>
		</>
	)
}

function MenuElemenmt(props) {
	return (
		<>
			<li className="menuitem" role="none">
				<button className="menuitem-name"
					role="menuitem" tabIndex="-1"
					aria-controls="frame-accessible-megamenu-2"
					aria-expanded="false"
					aria-haspopup="true">
					<span>
						{props.text}
					</span>
					<svg
						xmlns="http://www.w3.org/2000/svg" width="8" height="6"
						fill="none" aria-hidden="true">
						<use href="#icon-menu-arrow" />
					</svg>
				</button>
			</li>
		</>
	)
}
